
  <div class="media-bg" [ngStyle]="style"></div>
  